'use strict';

var auto = require('./auto.cjs');
var index = require('./numbers/index.cjs');
var units = require('./numbers/units.cjs');
var test = require('./test.cjs');

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [index.number, units.px, units.percent, units.degrees, units.vw, units.vh, auto.auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(test.testValueType(v));

exports.dimensionValueTypes = dimensionValueTypes;
exports.findDimensionValueType = findDimensionValueType;
//# sourceMappingURL=dimensions.cjs.map
